var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4697 6.46967C16.7626 6.17678 17.2374 6.17678 17.5303 6.46967L22.5303 11.4697C22.8232 11.7626 22.8232 12.2374 22.5303 12.5303L17.5303 17.5303C17.2374 17.8232 16.7626 17.8232 16.4697 17.5303C16.1768 17.2374 16.1768 16.7626 16.4697 16.4697L20.1893 12.75H8.75V15.1454C9.48296 15.4421 10 16.1607 10 17C10 18.1046 9.10457 19 8 19C6.89543 19 6 18.1046 6 17C6 16.1607 6.51704 15.4421 7.25 15.1454V12.75H2C1.58579 12.75 1.25 12.4142 1.25 12C1.25 11.5858 1.58579 11.25 2 11.25H3.25V8.85462C2.51704 8.55793 2 7.83934 2 7C2 5.89543 2.89543 5 4 5C5.10457 5 6 5.89543 6 7C6 7.83934 5.48296 8.55793 4.75 8.85462V11.25H11.25V8.85462C10.517 8.55793 10 7.83934 10 7C10 5.89543 10.8954 5 12 5C13.1046 5 14 5.89543 14 7C14 7.83934 13.483 8.55793 12.75 8.85462V11.25H20.1893L16.4697 7.53033C16.1768 7.23744 16.1768 6.76256 16.4697 6.46967Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/timeline.4416d172c61fbac62976361321858e50.svg";
export { ForwardRef as ReactComponent };